<template>
  <!-- <div >
      <slot v-bind:menu="menu" v-if="menu.length && !this.loading" />
  </div> -->
  <div v-if="!loading">
    <div class="col-xs-12 col-sm-6 col-md-3" v-for="item in menu" :key="item.id" >
      <h4>{{ item.link_text }}</h4>
      <nav class="vertical">
        <ul>
          <li v-for="(child, index) in item.children.data" :key="index">
            <template v-if="child.element && child.element.data">
              <a :href="getUrl(child)" :target="`${child.new_tab ? '_blank' : '_self'}`" :title="child.title || child.link_text" v-if="child.url">
                <span v-if="child.link_text">{{ child.link_text }}</span>
                <span v-else>{{ child.element.data.name }}</span>
              </a>
            </template>
            <template v-else>
              <a :href="`${child.url}`" :target="`${child.new_tab ? '_blank' : '_self'}`" :title="child.title || child.link_text" v-if="child.url">{{ child.link_text }}</a>
              <span v-else>{{ child.link_text }}</span>
            </template>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import Menu from '../Services/Menu.js'

export default {
  props: {
    handle: {
      type: String,
    },
    id: {
      type: String
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: true,
      menu: []
    }
  },
  methods: {
    getUrl (item) {
      if (item.element_type_name == 'product') {
        return `/products/${item.url}`
      }
      if (item.element_type_name == 'category') {
        return `/categories/${item.url}`
      }
      if (item.element_type_name == 'landingpage') {
        return `/${item.url}`
      }
      return item.url
    }
  },
  mounted () {
    Menu.tree(this.id, this.handle, this.preview).then(response => {
      this.menu = response.data
      console.log(this.menu)
    }).finally(response => {
      this.loading = false
    })
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/SiteMenu.vue